/** @format */

import { Card, Col, Row } from "antd";
import React from "react";
import TermsOfService from "../LoginContent/TermsOfServiceModal/TermsOfService";
import { Button } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const TermsOfServiceContent: React.FC<any> = () => {
  const navigate = useNavigate();
  function handleClickBack() {
    navigate(-1);
  }

  return (
    <Row justify="center" style={{ display: "flex", position: "relative" }}>
      <Button
        onClick={handleClickBack}
        style={{
          position: "absolute",
          left: "10px",
          top: "10px",
        }}
      >
        <LeftOutlined />
        Back
      </Button>
      <Col span={18}>
        <Card
          style={{
            background: "rgba(255, 255, 255, 0.8)",
            borderRadius: "4px",
            margin: "24px",
          }}
        >
          <TermsOfService />
        </Card>
      </Col>
    </Row>
  );
};

export default TermsOfServiceContent;
